export default "__VITE_ASSET__8d4d0509__"